export default __webpack_public_path__ + "fdd08f7fa894763c0b2f15f91d22bc33.png";